// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7c40a99a] .selectize-input {\n  background: #5b6064;\n  border-color: #303337;\n}\n", ""]);
// Exports
module.exports = exports;
